/* eslint-disable camelcase */
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    clientSecret: null,
  },
  mutations: {
    setClientSecret(state, clientSecret) {
      state.clientSecret = clientSecret;
    },
  },
  actions: {
    async getClientSecretFromStripe(_, { companyId, form }) {
      return $axios.post('register/' + companyId + '/intent', form);
    },
  },
  getters: {
    getClientSecret: (state) => {
      return state.clientSecret;
    },
  },
  plugins: [createPersistedState()],
});
